import React, { useRef, useEffect, useState } from 'react';

interface AnimateHeightProps {
    children: React.ReactNode;
    className?: string;
    duration?: number;
    isOpen?: boolean;
}

export const AnimateHeight = ({ children, className, duration = 250, isOpen = true }: AnimateHeightProps) => {
    const innerRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number | undefined>(undefined);
    const [isAnimating, setIsAnimating] = useState(false);
    const hasInitialized = useRef(false);

    useEffect(() => {
        if (!innerRef.current) return;

        const observer = new ResizeObserver(() => {
            if (!innerRef.current) return;
            const newHeight = innerRef.current.offsetHeight;

            if (hasInitialized.current) {
                setIsAnimating(true);
            } else {
                hasInitialized.current = true;
            }

            setHeight(newHeight);
        });

        observer.observe(innerRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (hasInitialized.current) {
            setIsAnimating(true);
        }
    }, [isOpen]);

    return (
        <div
            onTransitionEnd={() => setIsAnimating(false)}
            style={{
                overflow: !isOpen || isAnimating ? 'hidden' : 'visible',
                transition: hasInitialized.current ? `height ${duration}ms ease` : undefined,
                height: isOpen ? (height !== undefined ? height : 'auto') : 0,
            }}
        >
            <div ref={innerRef} className={className}>
                {children}
            </div>
        </div>
    );
};
